import { FC } from 'react';

import SearchBarInput from '@components/ui/search/SearchBarInput/SearchBarInput';
import CustomIcon from '@components/utils/CustomIcon';
import { PersonIcon } from '@assets/icons';
import {
  FlightGuestProps,
  FlightSearchBarProps,
} from '@components/views/flight/types';
import { getGuestText } from '@components/views/flight/utils';

import FlightGuestBox from './FlightGuestBox';
import useFlightGuests from './useFlightGuests';

export interface SearchBarFlightGuestBoxProps
  extends Pick<FlightSearchBarProps, 'onApplyGuestsForm'> {
  guestInfo: FlightGuestProps;
  className?: string;
}

const SearchBarFlightGuestBox: FC<SearchBarFlightGuestBoxProps> = ({
  guestInfo,
  onApplyGuestsForm,
  className,
}) => {
  const {
    numberOfAdultGuests,
    numberOfChildGuests,
    numberOfInfantGuests,
    removeAdult,
    addAdult,
    removeChild,
    addChild,
    removeInfant,
    addInfant,
    errorMessages,
    reset,
  } = useFlightGuests(guestInfo);

  return (
    <div className={className}>
      <SearchBarInput
        label='Kaç kişi yolculuk yapacaksınız?'
        InputComponent={getGuestText(guestInfo)}
        leftIcon={() => (
          <CustomIcon
            fontSize={28}
            paletteColor='primaryBrand'
            icon={PersonIcon}
          />
        )}
        popoverProps={{
          align: 'end',
          onClickOutside: () => {
            reset();
          },
        }}
        renderOverlayContent={(closePopup) => {
          return (
            <FlightGuestBox
              onApplyGuestsForm={(guestInfoParam) => {
                onApplyGuestsForm(guestInfoParam);
                closePopup();
              }}
              numberOfAdultGuests={numberOfAdultGuests}
              numberOfChildGuests={numberOfChildGuests}
              numberOfInfantGuests={numberOfInfantGuests}
              onRemoveAdult={removeAdult}
              onAddAdult={addAdult}
              onRemoveChild={removeChild}
              onAddChild={addChild}
              onRemoveInfant={removeInfant}
              onAddInfant={addInfant}
              errorMessages={errorMessages}
            />
          );
        }}
      />
    </div>
  );
};

export default SearchBarFlightGuestBox;
